import { useCustomers } from '@src/hooks/useCustomer';
import { useCustomerMarketAccounts } from '@src/providers';
import { Dialog, LoaderTalos, LoaderWrapper, type DialogProps } from '@talos/kyoko';
import { useMemo } from 'react';
import { DialogContents } from './DialogContents';

interface CustomerStatusDialogProps extends DialogProps {
  preselectedMarketAccount: string | undefined;
}

export function CustomerStatusDialog({
  preselectedMarketAccount: preselectedMktAcntName,
  ...props
}: CustomerStatusDialogProps) {
  const customers = useCustomers();
  const { customerMarketAccountsList, customerMarketAccountsByName } = useCustomerMarketAccounts();

  const isLoading = !customers || !customerMarketAccountsList;

  const preselectedMarketAccount = useMemo(
    () => (preselectedMktAcntName ? customerMarketAccountsByName.get(preselectedMktAcntName) : undefined),
    [customerMarketAccountsByName, preselectedMktAcntName]
  );

  return (
    <Dialog
      {...props}
      title="Look Up Customer Net Acquisition Status"
      showClose={true}
      suppressFooter={true}
      width={650}
      autoFocusFirstElement={true}
    >
      {isLoading ? (
        <LoaderWrapper>
          <LoaderTalos />
        </LoaderWrapper>
      ) : (
        <DialogContents
          customers={customers}
          customerMarketAccountsList={customerMarketAccountsList}
          preselectedMarketAccount={preselectedMarketAccount}
        />
      )}
    </Dialog>
  );
}
